import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-087f9237"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "box-select" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prefix" }, "Cofre Selecionado", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_tree_select, {
      value: _ctx.cofreSelected.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cofreSelected.value) = $event)),
      "tree-data": _ctx.selectTreeData,
      "field-names": {
        children: 'children',
        value: 'value',
        label: 'title',
      },
      placeholder: "Selecione o Cofre",
      "dropdown-style": { maxHeight: '600px', overflow: 'auto' },
      onChange: _ctx.handleChangeCofre,
      style: {"width":"55%"}
    }, null, 8, ["value", "tree-data", "onChange"])
  ]))
}